// @ts-nocheck
import { Trans } from '@lingui/react'
import classnames from 'clsx'
import { arrayOf, type InferProps, number, string } from 'prop-types'
import * as React from 'react'
import { type FunctionComponent, useEffect, useState } from 'react'
import { compose } from 'redux'

import { withI18n } from 'shared/utils/withI18n'
import Price from 'views/components/atoms/Price'
import TransWithHtml from 'views/components/utils/TransWithHtml'
import withMountPoints from 'views/enhancers/withMountPoints'
import { setTimeleft } from 'views/utils/nowCountdownTimer'
import { i18nType } from 'views/utils/propTypes'

import 'views/components/organisms/NowShippingModal/NowShippingModal.scss'

type NowDeliveryBoxProps = InferProps<typeof nowDeliveryBoxProps>

const NowDeliveryBox: FunctionComponent<NowDeliveryBoxProps> = ({
  deliveryDay,
  minimumOrder,
  deliveryRedpoints,
  secondsLeft,
  deliveryCost,
  availableSlots,
  carrierName,
  i18n,
}: NowDeliveryBoxProps): React.ReactElement => {
  const [countdownTime, setCountdownTime] = useState(secondsLeft)
  const [timeLeft, setTimeLeft] = useState('')

  useEffect(() => {
    setCountdownTime(secondsLeft?.toString())
  }, [secondsLeft])

  useEffect(() => {
    const interval = setTimeleft(countdownTime, setTimeLeft, setCountdownTime)

    return () => {
      if (interval) {
        clearInterval(interval)
      }
    }
  }, [countdownTime])

  return (
    <div
      className={classnames(
        'o-NowDeliveryBox l-flex l-flex__column l-flex__row@medium',
        { 'o-DeliveryBoxHeight': availableSlots?.length > 2 }
      )}
    >
      <div className="o-leftBox">
        <span className="o-DeliveryMessage">
          <Trans id="general.label.now.deliveryMessage" />
        </span>
        <br />

        <span className="o-DeliveryDay">{deliveryDay}</span>
        <br />
        <span className="o-DeliveryTime">
          <TransWithHtml
            text={i18n._('general.label.now.timeleft', { timeLeft })}
          />
        </span>
      </div>
      <div className="o-rightBox">
        <div className="o-textWrapper">
          <span className="o-leftMessage">
            <Trans id="general.label.now.deliveryWindow" />
          </span>
          {availableSlots?.map((slot, index) => (
            <>
              <span className="o-rightMessage">{slot || '--'}</span>
              {index !== availableSlots?.length - 1 && <br />}
            </>
          ))}
        </div>
        <div className="o-textWrapper">
          <span className="o-leftMessage">
            <Trans id="general.label.now.deliveryCost" />
          </span>
          <span className="o-rightMessage">
            <Price amount={deliveryCost / 100} />
          </span>
        </div>
        <div className="o-textWrapper">
          <span className="o-leftMessage">
            <Trans id="general.label.now.deliveryRedpoints" />
          </span>
          <span className="o-rightMessage">
            <Price amount={deliveryRedpoints / 100} />
          </span>
        </div>
        <div className="o-textWrapper">
          <span className="o-leftMessage">
            <Trans id="general.label.now.minimumOrder" />
          </span>
          <span className="o-rightMessage">
            <Price amount={minimumOrder / 100} />
          </span>
        </div>
        <div className="o-textWrapper">
          <span className="o-leftMessage">
            <Trans id="general.label.now.carrier" />
          </span>
          <span className="o-rightMessage">{carrierName || '--'}</span>
        </div>
      </div>
    </div>
  )
}

const nowDeliveryBoxProps = {
  deliveryDay: string,
  minimumOrder: number,
  deliveryCost: number,
  deliveryRedpoints: number,
  secondsLeft: number,
  carrierName: string,
  availableSlots: arrayOf(string),
  i18n: i18nType.isRequired,
}

NowDeliveryBox.propTypes = nowDeliveryBoxProps

export default compose(withMountPoints)(withI18n()(NowDeliveryBox))
